import { render } from "./StreetFoodArea.vue?vue&type=template&id=7d90ba8a&scoped=true"
import script from "./StreetFoodArea.vue?vue&type=script&lang=js"
export * from "./StreetFoodArea.vue?vue&type=script&lang=js"

import "./StreetFoodArea.vue?vue&type=style&index=0&id=7d90ba8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d90ba8a"]])

export default __exports__